import React from 'react';
import { useNavigate } from "react-router-dom";

import { AppContext } from '../../context/AppContext';
import { Headline, Richtext, Button } from '../../elements';
import { ContactForm, Layout } from '../../components';

import { buildingTypes, sizes } from '../../data/options.json';
import styles from './OverviewPage.module.scss';
import { BUILDING_PAGE, ELEVATOR_PAGE, ROOT } from '../../navigation/routes';
import { SET_ELEVATOR_INDEX, RESET, REMOVE_ELEVATOR, SET_MODE } from '../../context/ActionTypes';

const OverviewPage = () => {
	const { state, dispatch } = React.useContext(AppContext);
    const navigate = useNavigate();

    const findBuildingTypeLabel = () => {
        if (state.configuration.buildingType) {
            return buildingTypes.find((item) => item.value === state.configuration.buildingType).label;
        }
        return '';
    }

    const findSizeLabel = (sizeValue) => {
        return sizeValue ? sizes.find((item) => item.value === sizeValue).label : '';
    }

    const handleAddElevetor = () => {
        const index =  state.configuration.elevators.length;
        dispatch({ type: SET_ELEVATOR_INDEX, payload: index });
        dispatch({ type: SET_MODE, payload: 'new' });
        navigate(`${ELEVATOR_PAGE}/${index}`);
    }

    const handleEditConfiguration = index => {
        dispatch({ type: SET_ELEVATOR_INDEX, payload: index });
        dispatch({ type: SET_MODE, payload: 'edit' });
        navigate(`${ELEVATOR_PAGE}/${index}`);
    }

    const handleDeleteConfiguration = (index) => {
        const onAccept = window.confirm('Solle diese Konfiguration gelöscht werden?');

        if (onAccept) {
            dispatch({ type: REMOVE_ELEVATOR, payload: index });
        }
    }

    const handleNewConfiguration = () => {
        navigate(ROOT, { replace: true });
        dispatch({ type: RESET });
    }

	return (
		<Layout additionalClass={styles.wrapper}>
            <div className={styles.section}>
                <Headline variant='h2'>Gebäudeinformationen</Headline>
                <Richtext>
                    <p>
                        <span>{state.lead.street}</span><br />
                        <span>{state.lead.zip} {state.lead.city}</span><br />
                        <span>Deutschland</span><br /><br />

                        <span>Gebäudetyp: {findBuildingTypeLabel()}</span>
                    </p>
                </Richtext>
                <Button title="Informationen bearbeiten" variant="outline" onClick={() => navigate(`${BUILDING_PAGE}/edit`)}  />
            </div>

            {state.configuration.elevators.length > 0 ? <div className={styles.section}>
                <Headline variant='h2'>Übersicht der Konfiguration</Headline>
				{state.configuration.elevators.map((item, index) => (
                    <React.Fragment key={`rte_${index}`}>
                        <Richtext additionalClass={styles.rteWrapper}>
                            <div className={styles.sectionRow}><span>Aufzug:</span> <span>{item.display_name}</span></div>
                           {item.product && (
                               <div className={styles.sectionRow}>
                                    <span>Produkt:</span> <span>{item.product.name} <br /> 
                                    {findSizeLabel(item.product.size)}</span>
                                </div>
                            )}
                        </Richtext>
                        <div className={styles.buttonRow}>
                            <Button iconName="delete" variant="iconButton" onClick={() => handleDeleteConfiguration(index)} />        
                            <Button title="Konfiguration bearbeiten" variant="outline" onClick={() => handleEditConfiguration(index)} />
                        </div>
                    </React.Fragment>
                ))}
			</div> : null}

            <div className={styles.section}>
				<Richtext>
					<p>
                        Sie möchten eine Konfiguration für einen weiteren Aufzug ergänzen? Dann klicken Sie einfach auf
                        den nachfolgenden Button.
                    </p>
				</Richtext>
                <Button title="Weiteren Aufzug hinzufügen" onClick={() => handleAddElevetor()} />
			</div>

            <div className={styles.section}>
                <Headline variant='h2'>Kontaktdaten angeben</Headline>
				<Richtext>
					<p>
                        Zur Erstellung eines Angebots für Ihre Konfiguration nutzen Sie bitte das Formular.
                    </p>
				</Richtext>
                <ContactForm />
			</div>

            <div className={styles.section}>
                <Headline variant='h2'>Konfiguration abbrechen</Headline>
                <Richtext>
                    <p>
                        Sie möchten die Konfiguration abbrechen ohne ein Angebot anzufordern? Dann klicken Sie auf den nachfolgenden Button.
                    </p>
                </Richtext>
                <Button title="Neue Konfiguration" variant="outline" onClick={() => handleNewConfiguration()} />
            </div>

            
		</Layout>
	);
};

export default OverviewPage;
